import { createAction } from '@reduxjs/toolkit';

const logoOut = createAction('auth/logoOut');

export default logoOut;
